import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaBullhorn, FaHandsHelping, FaComments, FaUser } from "react-icons/fa";
import "./BottomNav.css";

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Load unread count from localStorage or default to 5
  const [unreadCount, setUnreadCount] = useState(
    parseInt(localStorage.getItem("unreadCount")) || 5
  );

  // Save to localStorage whenever unreadCount changes
  useEffect(() => {
    localStorage.setItem("unreadCount", unreadCount);
  }, [unreadCount]);

  // Helper function to check if a path is active
  const isActive = (path) => location.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);

    // If navigating to announcements, reset unread count to 0
    if (path === "/announcements") {
      setUnreadCount(0);
    }
  };

  return (
    <nav className="bottom-nav">
      <div
        className={`nav-item ${isActive("/announcements") ? "active" : ""}`}
        onClick={() => handleNavigation("/announcements")}
      >
        <div className="icon-wrapper">
          <FaBullhorn />
          {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
        </div>
        <p>Announcement</p>
      </div>

      <div
        className={`nav-item ${isActive("/request") ? "active" : ""}`}
        onClick={() => handleNavigation("/request")}
      >
        <FaHandsHelping />
        <p>Request</p>
      </div>

      <div
        className={`nav-item ${isActive("/messages") ? "active" : ""}`}
        onClick={() => handleNavigation("/messages")}
      >
        <FaComments />
        <p>Messages</p>
      </div>

      <div
        className={`nav-item ${isActive("/profile") ? "active" : ""}`}
        onClick={() => handleNavigation("/profile")}
      >
        <FaUser />
        <p>Profile</p>
      </div>
    </nav>
  );
};

export default BottomNav;